import axios from "axios";
import { EVERSIGN_DUCOMENTS_URL } from "../../API/Api";

const GetAllEverSignDocuments = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    console.log(data);
    let response = await axios({
        method: "GET",
        baseURL: `${EVERSIGN_DUCOMENTS_URL}`,
        headers: headers,
        params: { ...data },
    });
    return response.data;
};

const EverSignDocumentsService = {
    GetAllEverSignDocuments,
};

export default EverSignDocumentsService;
